module.exports = __webpack_public_path__ + "img/product.5c9fcdf8.png";